import type { ReactNode } from "react";
import { Link } from "react-router";
import { YabeMark } from "./Logo.tsx";

type Props = { icon?: ReactNode; text: string; cta?: { label: string; to: string } };

/** One sentence, one CTA (08-design.md §Principles 6). */
export function EmptyState({ icon = <YabeMark size={28} />, text, cta }: Props) {
  return (
    <div className="empty">
      <div className="empty__icon" aria-hidden="true">
        {icon}
      </div>
      <p className="empty__text">{text}</p>
      {cta ? (
        <Link className="btn btn--accent" to={cta.to}>
          {cta.label}
        </Link>
      ) : null}
    </div>
  );
}
